/**
 * Responsibility: take a copy of what this account holds, as one file.
 *
 * The export is built by the hub rather than assembled here, so it is the
 * same answer whatever asked for it. It carries holdings, likes, saved
 * searches, topics and bins - and never a notification credential, because
 * an Apprise URL is a live secret and a downloaded JSON file is the least
 * controlled place it could end up.
 */
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { hubApi } from '../../api/client';

export function AccountDataCard() {
  const download = () => {
    void hubApi.exportAccount().then((data) => {
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'dropmon-export.json';
      link.click();
      URL.revokeObjectURL(url);
    });
  };

  return (
    <Paper variant="outlined" sx={{ p: 3 }}>
      <Stack spacing={2}>
        <Typography variant="h6">Your data</Typography>
        <Divider />
        <Typography variant="body2" color="text.secondary">
          The export carries your holdings, likes, saved searches, topics and bins.
          It never carries a notification credential.
        </Typography>
        <Box>
          <Button variant="outlined" onClick={download}>
            Download my data
          </Button>
        </Box>
      </Stack>
    </Paper>
  );
}
